import { Chip, Typography } from "@mui/material";

interface Props {
  status: CarrierShipmentProgressStatusValue;
  size: "small" | "medium" | undefined;
}

const STATUS_BADGE_CONFIG: Record<
  Exclude<CarrierShipmentProgressStatusValue, "SENT">,
  { color: "success" | "warning" | "info"; label: string }
> = {
  QUOTED: { color: "success", label: "Quoted" },
  NO_CAPACITY: { color: "warning", label: "No truck available" },
  VIEWED: { color: "info", label: "Viewed" },
};

export function CarrierShipmentProgressStatusBadge(props: Props) {
  const { status, size } = props;

  // Sent is the default, no-signal-yet state, so it renders as plain muted
  // text rather than a chip.
  if (status === "SENT") {
    return (
      <Typography variant="body2" color="text.secondary">
        Sent
      </Typography>
    );
  }

  const { color, label } = STATUS_BADGE_CONFIG[status];

  return <Chip variant="outlined" size={size} label={label} color={color} />;
}
